import { create } from 'zustand';
import { TOption } from '@src/types';

interface TradovateTemplateStore {
  tradovateOptions: TOption[];
  setTradovateOptions: (options: TOption[]) => void;
}

export const useTradovateTemplateStore = create<TradovateTemplateStore>()((
  set
) => {
  return {
    tradovateOptions: [],
    setTradovateOptions: (options) =>
      set((state) => ({ ...state, tradovateOptions: options })),
  };
});
